import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=fad4fd0a&scoped=true"
var script = {}
import style0 from "./Contact.vue?vue&type=style&index=0&id=fad4fd0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad4fd0a",
  null
  
)

export default component.exports